export class BankInfoDetail {
  constructor({
    // Beneficiary Account Name
    account_name = (currency, countryCode) => null,
    // Beneficiary IBAN Number
    iban = (currency, countryCode) => null,
    // Beneficiary Address
    address = (currency, countryCode) => null,
    // Beneficiary Account Number
    account_number = (currency, countryCode) => null,
    // Intermediary Bank Swift Code
    intermediary_swift = (currency, countryCode) => null,
    // Beneficiary Bank Swift Code
    beneficiary_swift = (currency, countryCode) => null,
    // BSB Number
    bsb_number = (currency, countryCode) => null,
    // Beneficiary Bank Sort Code
    sort = (currency, countryCode) => null,
    // Beneficiary Bank Name
    bank_name = (currency, countryCode) => null,
    // Beneficiary Bank Address
    bank_address = (currency, countryCode) => null,
  }) {
    this.account_name = account_name
    this.iban = iban
    this.address = address
    this.account_number = account_number
    this.intermediary_swift = intermediary_swift
    this.beneficiary_swift = beneficiary_swift
    this.bsb_number = bsb_number
    this.sort = sort
    this.bank_name = bank_name
    this.bank_address = bank_address
  }

  toBankInfos(currency = null, countryCode = null) {
    return [
      ...(this.account_name(currency, countryCode) !== null
        ? [
            {
              title: 'common.field.beneAccName',
              info: this.account_name(currency, countryCode),
            },
          ]
        : []),
      ...(this.iban(currency, countryCode) !== null
        ? [
            {
              title: 'common.field.beneIban',
              info: this.iban(currency, countryCode),
            },
          ]
        : []),
      ...(this.address(currency, countryCode) !== null
        ? [
            {
              title: 'common.field.bankBeneAddress',
              info: this.address(currency, countryCode),
            },
          ]
        : []),
      ...(this.account_number(currency, countryCode) !== null
        ? [
            {
              title: 'common.field.beneAccNum',
              info: this.account_number(currency, countryCode),
            },
          ]
        : []),
      ...(this.intermediary_swift(currency, countryCode) !== null
        ? [
            {
              title: 'common.field.interBankswift',
              info: this.intermediary_swift(currency, countryCode),
            },
          ]
        : []),
      ...(this.beneficiary_swift(currency, countryCode) !== null
        ? [
            {
              title: 'common.field.beneBankswift',
              info: this.beneficiary_swift(currency, countryCode),
            },
          ]
        : []),
      ...(this.bsb_number(currency, countryCode) !== null
        ? [
            {
              title: 'common.field.bsbNum',
              info: this.bsb_number(currency, countryCode),
            },
          ]
        : []),

      ...(this.sort(currency, countryCode) !== null
        ? [
            {
              title: 'common.field.beneSort',
              info: this.sort(currency, countryCode),
            },
          ]
        : []),
      ...(this.bank_name(currency, countryCode) !== null
        ? [
            {
              title: 'common.field.beneBankName',
              info: this.bank_name(currency, countryCode),
            },
          ]
        : []),
      ...(this.bank_address(currency, countryCode) !== null
        ? [
            {
              title: 'common.field.beneBankAddress',
              info: this.bank_address(currency, countryCode),
            },
          ]
        : []),
    ]
  }
}
